module.exports = __webpack_public_path__ + "media/assets/images/cards_logos/amex-83a6330906b2439b053f0d5b1f7ee64f.svg";